import React from 'react';
import Utils from "../../common/Utils";
import CardTile from "../../components/CardTile/CardTile";
import {FarmersEndpoints, FBOEndpoints, MiscEndpoints, USSDEndpoints} from "../../common/ProxyEndpoints";
import SessionStateManager from "../../common/SessionStateManager";
import HTML from '../../common/HtmlHelpers';
import TTLProxy from "../../common/TTLAsyncProxy";
import {Badge, Button} from 'reactstrap';
import {CreationLineChart} from "./DashboardCommon";
import FormRenderer from "../../common/FormRenderer/FormRenderer";
import FarmersCommon from '../Farmers/FarmersCommon';
import DialogCollapseSection from "../../components/DialogCollapseSection/DialogCollapseSection";
import {ic_person_add as FarmerAddIcon} from 'react-icons-kit/md/ic_person_add';
import DocumentTitle from 'react-document-title';
import Icon from 'react-icons-kit';
import {RequestTimeFrame} from "../../common/Constants";
import SmartDialog from "../../components/SmartDialog/SmartDialog";
import MDProgress from 'react-md-progress-bar';
import TractorRequestBuilder from "../../components/TractorRequestBuilder/TractorRequestBuilder";
import {getDistricts, getLocationRecord, getWards, listProvinces} from "../../data/locations";

const CacheDependency = [
  "farmers"
];


/**
 * Dashboard - FBO View
 */
export default class DashboardFBO extends React.Component {

    constructor(props){
        super(props);

        const session = new SessionStateManager('fbo_dashboard', false);
        this.session = session;
        this.proxy = TTLProxy.getInstance();
        this.state = {

            isLoaded: session.getState('isLoaded',false),
            faulted: session.getState('faulted',false),
            stats: session.getState('stats',{
                farmers: {

                    //  The total farmers
                    total: 0,

                    gender: {

                        //  Male Farmers
                        male: 0,

                        //  Female Farmers
                        female: 0,

                        //  Unassigned Gender
                        unassigned: 0
                    },

                    //  The creation statistics
                    creation :{

                        //  Total farmers created today
                        today: 0,

                        //  Total farmers created this week
                        week: 0,

                        //  Total farmers created this month
                        month: 0
                    }
                },

                requests: {

                    //  Total number of requests made by the farmers of the FBO
                    total: 0,

                    //  The total number of assigned requests
                    assigned: 0,

                    //  The total number of completed requests
                    completed: 0,

                    //  The total number of acres assigned
                    totalAssignedAcres: 0,

                    //  THe total number of hectares assigned
                    totalAssignedHectares: 0,

                    //  The total number of acres completed
                    totalCompletedAcres: 0,

                    //  The total number of completed hectares
                    totalCompletedHectares: 0,

                    //  Total income they've generated generated
                    totalIncome: 0,

                    //  Total income for currently assigned but not completed requests
                    totalPendingIncome: 0,

                    //  The creation statistics
                    creation: {

                        //  Total requests today
                        today: 0,

                        //  Total requests this week
                        week: 0,

                        //  Total requests this month
                        month: 0
                    }
                }
            }),

            //  Farmer Create Chart Statistics
            farmerCreateStats: null,

            //  Request Order Chart Statistics
            requestsOrderStats: null,

            //  USSD Services
            services: [],

            //  The state of dialogs
            dialogStates: {},

            //  The farmers for requesting for services
            farmers: null,

            //  Indicates busy state
            isBusy: false,

            //  Indicates creating state
            isCreating: false
        };

        this._isMounted = false;
    }


    fetchDashboardStats(){
        return this.proxy.processRequest(MiscEndpoints.getFBODashboardStats(this.getFBOId())).then(response => response.getPayload());
    }

    fetchFarmerAnalytics(){
        return this.proxy.processRequest(FBOEndpoints.getFarmerCreateStats(this.getFBOId(), RequestTimeFrame.Month , { min : 4, max: 4} , 1)).then(response => response.getPayload());
    }

    fetchRequestAnalytics(){
        return this.proxy.processRequest(FBOEndpoints.getRequestStats(this.getFBOId(),RequestTimeFrame.Month , { min : 4, max: 4} , 1)).then(response => response.getPayload());
    }

    fetchUSSDServices(){

        const endpoint = USSDEndpoints.getUSSDServices();
        endpoint.include = ["pricing"];
        return this.proxy.processRequest(endpoint).then(response => response.getPayload());
    }


    fetchFarmers(){

        const endpoint = FBOEndpoints.getFBOFarmers(this.getFBOId());
        return this.proxy.processRequest( endpoint.url , {
            method: endpoint.method,
            fields: ['id','name']
        }).then(response => response.getPayload());
    }

    setStateSafe(state,callback){

        if(this._isMounted){
            this.setState(state,callback);
        }

    }

    loadState(){

        const proxy = this.proxy;
        const me = this;

        return Promise.all([

            this.fetchDashboardStats().then(payload =>{

                me.setStateSafe({
                    stats: payload,
                });

            }),

            this.fetchFarmerAnalytics().then(payload =>{

                me.setStateSafe({
                    farmerCreateStats: payload
                });

            }),

            this.fetchRequestAnalytics().then(payload =>{

                me.setStateSafe({
                    requestsOrderStats: payload
                });

            }),

            this.fetchUSSDServices().then(services =>{

                me.setStateSafe({
                    services: services
                });

            })

        ]).then(values => {

            me.setState({
                faulted: false,
                isLoaded: true
            });

        }).catch(err => me.enterErrorState(err));

    }

    enterErrorState(err){

        alert(err);

        //  Show warning message
        HTML.toastWarning(Utils.getResponseError(err));

        //  Set the state
        this.setState({ faulted: true });

    }

    getFBOId(){
        return this.proxy.getUserInfo().fbo.id;
    }

    persistSession(){

        this.session.putStateFrame({
            isLoaded: this.state.isLoaded,
            faulted: this.state.faulted,
            stats: this.state.stats
        }).save();
    }

    componentWillUnmount(){
        this.persistSession();
        this._isMounted = false;
    }

    componentDidMount(){

        this._isMounted = true;

        //
        if(!this.state.isLoaded  || this.state.faulted)
            return this.loadState();

    }

    componentWillMount(){

        //  TODO: Load stuffs here

    }

    navigateUrl(url , args){
        this.props.history.push(url,args);
    }

    onCreateFarmer(payload){

        const state  = this.state;
        const form = this._createFarmerForm;
        if(state.isCreating){
            return;
        }

        //
        this.setStateSafe({
            isCreating: true,
        });


        if(payload.province && payload.district && payload.ward){

            const loc = getLocationRecord(payload);
            if(loc){
                payload.farm_location = [payload.province,payload.district,payload.ward].join(",");
                payload.farm_location_lat = loc.lat;
                payload.farm_location_long = loc.lng;
            }

        }

        //  push create farmer
        return this.proxy.processRequest( FarmersEndpoints.create(this.getFBOId(), payload ) ).then(response => {

            return Promise.all([
               this.fetchFarmerAnalytics(),
               this.fetchDashboardStats(),
                this.fetchRequestAnalytics()
            ]).then(values => {

                //
               this.setStateSafe({
                   farmerCreateStats: values[0],
                   stats: values[1],
                   requestsOrderStats: values[2]
               });

                //  Toggle dialog
                this._addFarmer.toggle();

                //
                HTML.toastSuccess("Farmer added successfully!");

                //
                Utils.eraseSession(CacheDependency);

            });

        }).catch(ex => {

            //  set form exception
            form.updateException(ex);

            HTML.toastError(Utils.getResponseError(ex));

        }).then(() => {

            //  remove from busy state
            this.setStateSafe({
                isCreating : false
            });

        });

    }


    onShowCreateFarmer(editItem){

        const _provinceList = listProvinces();
        const _selectProvince = (editItem ? editItem.province : "" );
        const _districtList = _selectProvince ? getDistricts(_selectProvince) : [];
        const _selectDistrict = (editItem ? editItem.district : "" );
        const _wardList = (_selectProvince && _selectDistrict) ? getWards(_selectProvince,_selectDistrict) : [];

        return this.setStateSafe({
            _locationMode: editItem && (editItem.province && editItem.district && editItem.ward) ? 'select' : 'custom',
            _selectProvince,
            _selectDistrict,
            _provinceList,
            _districtList,
            _wardList
        } , () => this._addFarmer.show());

    }

    renderModals(){

        const state = this.state;
        return (<div>


                <SmartDialog title={"Register Farmer"} showCancelButton={false} ref={r => this._addFarmer = r}>

                    <FormRenderer inputs={FarmersCommon.getFarmerInputs(undefined,{
                        locationMode: this.state._locationMode,
                        onLocationModeChange: mode => {
                            this.setStateSafe({ _locationMode: mode })
                        },
                        provinces: this.state._provinceList,
                        districts: this.state._districtList,
                        wards: this.state._wardList,
                        onProvinceChanged: value => {

                            const _districtList = value ? getDistricts(value) : [];
                            const _selectDistrict = _districtList.length > 0 ? _districtList[0].value : "";
                            const _wardList =  _selectDistrict ? getWards(value,_selectDistrict) : [];
                            const _selectWard = _wardList.length > 0 ?  _wardList[0].value : "";

                            this.setState({
                                _selectProvince: value,
                                _selectDistrict,
                                _districtList,
                                _wardList
                            },() => {

                                const renderer  = this._createFarmerForm;
                                renderer.setInputValueWithName('district', _selectDistrict );
                                renderer.setInputValueWithName('ward', _selectWard);

                            });

                        },
                        onDistrictChanged: value => {

                            const _wardList = getWards(this.state._selectProvince,value);
                            const _selectWard = _wardList[0].value;

                            this.setState({
                                _selectDistrict: value,
                                _wardList
                            }, () => {

                                const renderer  = this._createFarmerForm;
                                renderer.setInputValueWithName('ward', _selectWard);

                            });

                        }
                    })}
                                  onSubmit={this.onCreateFarmer.bind(this)}
                                  ref={r => this._createFarmerForm = r}>
                        <hr/>
                        {state.isCreating && <MDProgress show={true} overlay={true} />}
                        <Button className="btn-green" block><Icon icon={FarmerAddIcon}/> Register Farmer</Button>
                    </FormRenderer>

                </SmartDialog>

                <TractorRequestBuilder ref={r => this._createRequestDlg = r}
                                       onBuildRequest={payload => {

                                           return {
                                               query: {
                                                   fbo:  this.getFBOId()
                                               }
                                           };

                                       }}
                                       fetchFarmers={params => (this.proxy.processRequest({
                                           ...FBOEndpoints.getFBOFarmers(this.proxy.getUserInfo().fbo.id),
                                           ...params
                                       }))}
                                       onRequestCreated={request => {

                                           //  refresh list
                                           return this.loadState();

                                       }}/>

        </div>);
    }

    render(){

        const state = this.state;
        const stats = state.stats;
        const farmerCreateChart = state.farmerCreateStats ? state.farmerCreateStats.farmers : null;
        const requestsCreateChart = state.requestsOrderStats ? state.requestsOrderStats.requests : null;

        return (<DocumentTitle title={"FBO Dashboard"}>

                    <div>
                        <div className="container-fluid">
                            <div className="animated fadeIn">
                                <div className="row content-frame">
                                    <div className="col-sm-8 col-md-6">

                                        <CardTile classes="card-inverse card-info"
                                                  icon="fa fa-tree"
                                                  title="Total Farmers"
                                                  value={stats.farmers.total}
                                                  tooltipTitle="Farmers"
                                                  tooltipContent="Displays the total number of farmers you currently posses"
                                                  navigateText="Click to see"
                                                  onClick={() => this.navigateUrl('/farmers')} />

                                    </div>

                                    <div className="col-sm-8 col-md-3">

                                        <CardTile classes="card-inverse card-success"
                                                  icon="fa fa-male"
                                                  title="Farmers (Male)"
                                                  value={stats.farmers.gender.male }
                                                  tooltipTitle="Total Male Farmers"
                                                  tooltipContent="Indicates the total number of male farmers"
                                                  navigateText="Click to see"
                                                  onClick={() => this.navigateUrl('/farmers?gender=male')}/>
                                    </div>

                                    <div className="col-sm-8 col-md-3">

                                        <CardTile classes="card-inverse card-success"
                                                  icon="fa fa-female"
                                                  title="Farmers (Females)"
                                                  value={stats.farmers.gender.female}
                                                  tooltipTitle="Total Female Farmers"
                                                  tooltipContent="Indicates the total number of registered tractor operators."
                                                  navigateText="Click to see"
                                                  onClick={() => this.navigateUrl('/farmers?gender=female')}/>
                                    </div>

                                </div>

                                <Button className="btn-green" block style={{ marginBottom: 10 }} onClick={() => this.onShowCreateFarmer()}><Icon icon={FarmerAddIcon} /> Add Farmer</Button>

                            </div>
                        </div>
                    <div style={{backgroundColor: 'white'}}>
                        <div className="container-fluid" >

                            <div className="stats-bottom animated fadeIn" >

                                <DialogCollapseSection  initiallyOpen={true} title={"Farmers"}>
                                    <div>
                                    <div className="row">
                                        <div className="col-md-8">
                                            <p>Below is a chart which indicates the rate at which your farmers are added</p>
                                            <div className="card">
                                                <div className="card-body">
                                                    <CreationLineChart labelFormat="MMM YYYY" title="Farmers (Created)" data={farmerCreateChart} height={180}/>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-4">
                                            <b>Recently Added</b>
                                            <hr/>

                                            <h6><Badge pill={true}>Today: {stats.farmers.creation.today}</Badge></h6>
                                            <h6><Badge pill={true}>This Week: {stats.farmers.creation.week}</Badge></h6>
                                            <h6><Badge pill={true}>This Month: {stats.farmers.creation.month}</Badge></h6>
                                        </div>

                                    </div>

                                </div>
                                </DialogCollapseSection>

                                <hr/>

                                <DialogCollapseSection initiallyOpen={true} title={"Tractor Requests"}>
                                <div>
                                    <div className="row">

                                        <div className="col-md-4">
                                            <p>The chart beside shows the tractor requests ordered by you for your farmers</p>
                                            <b>Recently Requested</b>
                                            <hr/>

                                            <h6><Badge pill={true}>Today: {stats.requests.creation.today}</Badge></h6>
                                            <h6><Badge pill={true}>This Week: {stats.requests.creation.week}</Badge></h6>
                                            <h6><Badge pill={true}>This Month: {stats.requests.creation.month}</Badge></h6>

                                        </div>

                                        <div className="col-md-8">
                                            <div className="card">
                                                <div className="card-body">
                                                    <CreationLineChart fill={false} labelFormat="MMM YYYY" title="Requests (Ordered)" data={requestsCreateChart} height={180}/>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                    <Button className="btn-green" block style={{ marginBottom: 10 }} onClick={() => this._createRequestDlg.show()}><i className="fa fa-plus" ></i> Request Tractor Service</Button>

                                </div>
                                </DialogCollapseSection>

                            </div>

                        </div>
                    </div>

                    {this.renderModals()}
                    </div>
        </DocumentTitle>);
    }

}


// WEBPACK FOOTER //
// ./src/views/Dashboard/DashboardFBO.js